<template>
    <div>
        <Modal v-model="modalEdit"
               :width="600"
               :title="(envType === 'VMware' || !envType ) ? $i18n.t('编辑网络') : $i18n.t('编辑私有网络')"
               class="edit-vpc"
               :mask-closable="false"
               @on-cancel="cancelEdit">
            <Form ref="formEdit"
                  :label-width="120"
                  :model="formDataEdit"
                  :rules="ruleEdit">
                <FormItem :label="$i18n.t('网络名称') + '：'"
                          prop="name">
                    <Input v-model="formDataEdit.name"
                           :placeholder="$i18n.t('请输入') + ' ' + $i18n.t('名称')"
                           style="width:240px"
                           :maxlength="225"
                           class="form-item" />
                    <Poptip trigger="hover"
                            placement='right'
                            word-wrap
                            :transfer="true"
                            width="300"
                            v-if=" ['Aliyun','Qcloud','HuaweiCloud','Aws', 'HCSO'].includes(detailData.cloudEnvType) ">
                        <i class="icon-prompt-1-o"></i>
                        <div slot="content"
                             v-if="['HuaweiCloud', 'HCSO'].includes(detailData.cloudEnvType)">{{$i18n.t('只能由中文、英文字母、数字、下划线、中划线、点组成')}}</div>
                        <div slot="content"
                             v-if="detailData.cloudEnvType === 'Aws'">{{$i18n.t('2-255网络名称验证消息')}}</div>
                        <div slot="content"
                             v-else>{{$i18n.t('长度为2-128个字符，以大小字母或中文开头，可包含数字，"_"或"-"')}}</div>
                    </Poptip>
                </FormItem>
                <FormItem v-if="isShowDescription"
                          :label="$i18n.t('描述')+ '：'"
                          prop="description">
                    <Input v-model.trim="formDataEdit.description"
                           type="textarea"
                           :autosize=" { minRows: 4, maxRows: 6 }"
                           :placeholder="$i18n.t('请输入') + '...'"
                           class="form-item"
                           style="width:400px" />
                    <Poptip trigger="hover"
                            placement='right'
                            word-wrap
                            :transfer="true"
                            width="300"
                            v-if="['Aliyun','Aws'].includes(detailData.cloudEnvType)">
                        <i class="icon-prompt-1-o"></i>
                        <div slot="content">{{$i18n.t('网络描述规则')}}</div>
                    </Poptip>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelEdit"
                        type="text"
                        class="ivu-btn-text">{{$i18n.t('取消')}}</Button>
                <Button type="primary"
                        :loading="loading"
                        @click="submitEdit">{{$i18n.t('保存')}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import API from '@/service/api.js'
export default {
    name: 'editinfomodal',
    props: ['detail', 'envType'],
    data () {
        const validateName = (rule, value, callback) => {
            if (['Aliyun', 'Qcloud', 'Aws'].includes(this.detailData.cloudEnvType) && !/^[a-zA-Z\u4E00-\u9FA5]+[a-zA-Z0-9\u4E00-\u9FA5_-]{1,127}$/.test(value)) {
                callback(new Error(this.$t('名称格式不合法')))
            } else if ((['HuaweiCloud', 'HCSO'].includes(this.detailData.cloudEnvType)) && !new RegExp('^[\u4e00-\u9fa5_a-zA-Z0-9.-]{1,127}$').test(value)) {
                callback(new Error(this.$t('名称格式不合法')))
            } else {
                callback()
            }
        }
        const validateDsc = (rule, value, callback) => {
            const desc = value && value.replace(/\s/g, '@')
            const descReg = /^((http:\/\/)|(https:\/\/))\S{2,256}/
            if (['Aliyun', 'Aws'].includes(this.detailData.cloudEnvType)) {
                if (this.detailData.cloudEnvType === 'Aliyun' && !value) {
                    callback()
                }
                if (desc && !descReg.test(desc)) {
                    callback()
                } else {
                    callback(new Error(this.$t('描述格式不合法')))
                }
            } else {
                callback()
            }
        }
        return {
            modalEdit: false,
            ruleEdit: {
                name: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'blur' },
                    { validator: validateName, trigger: 'blur' }
                ],
                description: [
                    { validator: validateDsc, trigger: 'blur' }
                ]
            },
            loading: false,
            detailData: {},
            formDataEdit: {
                name: null,
                description: null
            }
        }
    },
    computed: {
        isShowDescription () {
            const envArr = ['ESCloud', 'ESCloud-Admin', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'VMware', 'Aliyun', 'ApsaraStack', 'Maas']
            if (envArr.includes(this.detailData.cloudEnvType) || envArr.includes(this.envType)) {
                return true
            }
            return false
        }
    },
    watch: {
        detail (val) {
            this.formDataEdit.name = val.name
            this.formDataEdit.description = val.description
            this.detailData = val
        }
    },
    methods: {
        // 打开弹窗,获取详情数据
        openModal () {
            this.modalEdit = true
            if (this.detail) {
                this.formDataEdit.name = this.detail.name
                this.formDataEdit.description = this.detail.description
                this.detailData = this.detail
            }
        },
        // 编辑时取消
        cancelEdit () {
            this.$refs.formEdit.resetFields()
            this.modalEdit = false
            this.loading = false
        },
        // 编辑时保存
        submitEdit () {
            const editData = {
                id: this.detailData.id,
                name: this.formDataEdit.name,
                description: this.formDataEdit.description,
                cloudEnvId: this.detailData.cloudEnvId
            }
            this.$refs.formEdit.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.axios.put(this.urlFormat(API.GET_ENV_VPC, false), editData).then(res => {
                        if (res.status) {
                            this.cancelEdit()
                            this.$emit('refresh')
                        }
                        this.loading = false
                    }).catch(e => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        }
    }
}
</script>
<style lang="less">
.edit-vpc {
    .icon-prompt-1-o {
        cursor: pointer;
        color: #2d8cf0;
        margin-left: 10px;
    }
}
</style>
